import Carousel from "@/components/slider/Carousel";
import VideoCard from "../items/VideoCard";

function CarouselTopVideo({
  title,
  showMoreText,
  showMoreLink,
  data,
  videoHeight,
  totalAmount,
  container,
}) {
  return (
    <Carousel
      title={title}
      showMoreLink={showMoreLink}
      spaceBetween={12}
      breakpoints={{
        960: {
          spaceBetween: 24,
        },
      }}
      totalAmount={totalAmount}
      container={container}
    >
      {data.map((item, index) => (
        <VideoCard
          videoHeight={videoHeight}
          data={item}
          key={`video-${item.uuid}`}
          container={container}
        />
      ))}
    </Carousel>
  );
}
export default CarouselTopVideo;
